import { iocNames } from '../iocNames';
import { useInject } from './useInject';
import { WithdrawService } from '../services/WithdrawService';

export function useWithdrawService() {
  return useInject<WithdrawService>(iocNames.withdrawService);
}
